module.exports = __webpack_public_path__ + "static/img/contact_bg.15af273.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/contact_bg.png
// module id = ccR/
// module chunks = 8